module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "icon": "",
            "loading": _vm.downloading || _vm.getClientsRequest.loading
          },
          on: {
            "click": _vm.download
          }
        }, on), [_c('v-icon', [_vm._v("cloud_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Download your client list as a csv file")])]), _vm._v("\n    Clients\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/clients/merge"
    }
  }, [_c('v-icon', [_vm._v("merge_type")]), _vm._v("\n      Merge clients\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'CreateClient')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" New client\n    ")], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.requests.appointmentInRange
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "hidden-xs-only"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_vm._v("\n        You saw these\n        "), _c('v-chip', {
    staticClass: "green white--text",
    attrs: {
      "label": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.clientsInRange.length) + " clients\n        ")], 1), _vm._v("\n        from\n        "), _c('v-chip', {
    attrs: {
      "label": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("ACTIVATE_RANGE_PICKER")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("event")]), _vm._v(" " + _vm._s(_vm.globalActiveDateRangeFormatted) + "\n        ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('birthday-bar')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.visibleClients), function(clientId) {
    return _c('v-flex', {
      key: clientId,
      attrs: {
        "xs12": "",
        "md6": "",
        "lg6": "",
        "xl4": ""
      }
    }, [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [(_vm.getClientById(clientId) && _vm.getClientById(clientId).id) ? _c('client-list-item', {
      attrs: {
        "client": _vm.getClientById(clientId),
        "relationship-id": _vm.getClientById(clientId).id,
        "with-details": false
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.gotoClient(clientId)
        }
      }
    }, [_c('v-list-tile-sub-title', {
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.appointmentsByClient[clientId].length) + " appointment"), (_vm.appointmentsByClient[clientId].length > 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(".\n                Due: " + _vm._s(_vm.formatCurrency(_vm.appointmentsByClient[clientId][0].currency, _vm.appointmentsByClient[clientId].totalOwed)) + ".\n                Paid: " + _vm._s(_vm.formatCurrency(_vm.appointmentsByClient[clientId][0].currency, _vm.appointmentsByClient[clientId].totalPaid)) + "\n              ")])], 1) : _c('v-list-tile', [_c('v-list-tile-action', [_c('v-progress-circular', {
      attrs: {
        "width": "2",
        "indeterminate": "",
        "color": "amber"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("loading ..")])], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)
  }), 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "pt-2"
  }, [_vm._v("Showing " + _vm._s(_vm.displayLimit) + " of " + _vm._s(_vm.clientsInRange.length))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.displayLimit += _vm.displayLimit
      }
    }
  }, [_vm._v("Load more")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62490498","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ClientHome.vue
// module id = 1444
// module chunks = 9